"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _core = require("@material-ui/core");

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Link = _interopRequireDefault(require("../../Link"));

var _classnames = _interopRequireDefault(require("classnames"));

var _baseModule = _interopRequireDefault(require("./base.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

// @flow
var validColors = ['default', 'inherit', 'primary', 'secondary'];
var validVariants = ['text', 'outlined', 'contained'];
var validAligns = ['center', 'left'];
var validTextTransform = ['uppercase', 'none', 'lowercase'];
/**
 * The main button component
 **/

var Button = function Button(props) {
  var _cn;

  // This generates the base theme for the button
  var children = props.children,
      onClick = props.onClick,
      color = props.color,
      align = props.align,
      texttransform = props.texttransform,
      fullHeight = props.fullHeight,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$startIcon = props.startIcon,
      startIcon = _props$startIcon === void 0 ? false : _props$startIcon,
      _props$endIcon = props.endIcon,
      endIcon = _props$endIcon === void 0 ? false : _props$endIcon,
      _props$round = props.round,
      round = _props$round === void 0 ? false : _props$round,
      _props$link = props.link,
      link = _props$link === void 0 ? false : _props$link,
      _props$external = props.external,
      external = _props$external === void 0 ? false : _props$external,
      _props$anchor = props.anchor,
      anchor = _props$anchor === void 0 ? false : _props$anchor,
      id = props.id,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$buttonLink = props.buttonLink,
      buttonLink = _props$buttonLink === void 0 ? false : _props$buttonLink,
      _props$extraBold = props.extraBold,
      extraBold = _props$extraBold === void 0 ? false : _props$extraBold,
      _props$size = props.size,
      size = _props$size === void 0 ? 'large' : _props$size,
      _props$bold = props.bold,
      bold = _props$bold === void 0 ? false : _props$bold,
      _props$small = props.small,
      small = _props$small === void 0 ? false : _props$small,
      type = props.type,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      loading = props.loading;
  var variant = props.variant,
      _props$flat = props.flat,
      flat = _props$flat === void 0 ? false : _props$flat; // Also support variant="flat" as variant="contained" and flat=true
  // @ts-ignore

  if (variant === 'flat') {
    variant = 'contained';
    flat = true;
  }

  var customClasses = (0, _classnames.default)(_baseModule.default[variant], _baseModule.default[color], (_cn = {}, (0, _defineProperty2.default)(_cn, _baseModule.default.disabled, disabled), (0, _defineProperty2.default)(_cn, _baseModule.default.fullHeight, fullHeight), (0, _defineProperty2.default)(_cn, _baseModule.default[align], align && validAligns.includes(align) ? align : 'center'), (0, _defineProperty2.default)(_cn, _baseModule.default.flat, flat), (0, _defineProperty2.default)(_cn, _baseModule.default.shapeRound, round), (0, _defineProperty2.default)(_cn, _baseModule.default.endIcon, endIcon), (0, _defineProperty2.default)(_cn, _baseModule.default.startIcon, startIcon), (0, _defineProperty2.default)(_cn, _baseModule.default.extraBold, extraBold), (0, _defineProperty2.default)(_cn, _baseModule.default.bold, bold), (0, _defineProperty2.default)(_cn, _baseModule.default.small, small), (0, _defineProperty2.default)(_cn, _baseModule.default.light, light), (0, _defineProperty2.default)(_cn, _baseModule.default.fullWidth, fullWidth), (0, _defineProperty2.default)(_cn, _baseModule.default.animate, loading === null || loading === void 0 ? void 0 : loading.animate), (0, _defineProperty2.default)(_cn, _baseModule.default.loading, loading === null || loading === void 0 ? void 0 : loading.start), (0, _defineProperty2.default)(_cn, _baseModule.default.end, loading === null || loading === void 0 ? void 0 : loading.end), (0, _defineProperty2.default)(_cn, _baseModule.default[texttransform], texttransform && validTextTransform.includes(texttransform) ? texttransform : 'uppercase'), (0, _defineProperty2.default)(_cn, className, className), _cn));
  return link || anchor !== false && !buttonLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default // @ts-ignore
  , {
    className: (0, _classnames.default)(_baseModule.default.silentLink, customClasses),
    to: "".concat(link ? link : '').concat(anchor ? anchor : ''),
    external: external,
    anchor: anchor !== false,
    id: id,
    title: title,
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
    id: id,
    type: type,
    disabled: disabled || (loading === null || loading === void 0 ? void 0 : loading.start),
    startIcon: startIcon,
    endIcon: endIcon,
    size: size // @ts-ignore
    ,
    color: validColors.includes(color) ? color : 'inherit',
    variant: validVariants.includes(variant) ? variant : 'text',
    classes: {
      root: _baseModule.default.root,
      label: _baseModule.default.label
    },
    className: "".concat(customClasses, " ").concat(className),
    title: title,
    onClick: onClick,
    children: [children && !loading && children, children && loading && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Box, {
        className: "".concat(_baseModule.default.children, " ").concat(loading.start ? _baseModule.default.loading : '', " ").concat(loading.end ? _baseModule.default.end : ''),
        children: children
      }), loading.start && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {
        className: _baseModule.default.circularProgress,
        size: 20
      }), loading.end && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Done.default, {
        className: _baseModule.default.doneIcon
      })]
    })]
  });
};

var _default = Button;
exports.default = _default;